import { render, staticRenderFns } from "./EmptyCartComponent.vue?vue&type=template&id=3fda9c34&scoped=true&"
import script from "./EmptyCartComponent.vue?vue&type=script&lang=js&"
export * from "./EmptyCartComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fda9c34",
  null
  
)

export default component.exports